import {
  RESCHEDULE_SET_LIST,
  RESCHEDULE_SET_TOTAL,
  RESCHEDULE_SET_LOADING_STATUS_LIST,
  RESCHEDULE_SET_LOADING_STATUS_TOTAL,
  RESCHEDULE_CLEAR_ALL,
  RESCHEDULE_SET_SEARCH_PARAMS
} from '../types'
import rescheduleService from '../../api/reschedule'
import notify from '@/api/notification'
import analytics from '../../api/analytics'
import strings from '@/strings'

const state = {
  reschedules: [],
  totalReschedules: 0,
  loadingStatusList: 'STATUS_INITIAL',
  loadingStatusTotal: 'STATUS_INITIAL',
  orderId: null
}

const mutations = {
  [RESCHEDULE_SET_LIST] (state, reschedules) {
    state.reschedules = state.reschedules.concat(reschedules)
  },
  [RESCHEDULE_SET_TOTAL] (state, total) {
    state.totalReschedules = total
  },
  [RESCHEDULE_SET_LOADING_STATUS_LIST] (state, status) {
    state.loadingStatusList = status
  },
  [RESCHEDULE_SET_LOADING_STATUS_TOTAL] (state, status) {
    state.loadingStatusTotal = status
  },
  [RESCHEDULE_SET_SEARCH_PARAMS] (state, params) {
    state.orderId = params.orderId
  },
  [RESCHEDULE_CLEAR_ALL] (state) {
    state.reschedules = []
    state.totalReschedules = 0
    state.loadingStatusList = 'STATUS_INITIAL'
    state.loadingStatusTotal = 'STATUS_INITIAL'
    state.orderId = null
  }
}

const getters = {
  rescheduleList: state => {
    return state.reschedules
  },
  reschedulesTotal: state => {
    return state.totalReschedules
  },
  rescheduleListStatusLoading: state => {
    return state.loadingStatusList
  },
  isRescheduleListStatusLoading: state => {
    return state.loadingStatusList === 'STATUS_LOADING'
  },
  isRescheduleTotalStatusLoading: state => {
    return state.loadingStatusTotal === 'STATUS_LOADING'
  }
}

const actions = {
  getRescheduleList: function ({ commit, state }) {
    commit(RESCHEDULE_SET_LOADING_STATUS_LIST, 'STATUS_LOADING')
    rescheduleService.getRescheduledOrders(state.orderId).then(response => {
      let reschedules = response.data
      commit(RESCHEDULE_SET_LIST, reschedules)

      if (reschedules.length === strings.listsLimits.reschedule) {
        commit(RESCHEDULE_SET_LOADING_STATUS_LIST, 'STATUS_SUCCESS')
      } else {
        commit(RESCHEDULE_SET_LOADING_STATUS_LIST, 'STATUS_END')
      }
      submitAnalyticsEvent('Busca por' + state.status + 'Ultimos dias:' + state.previousDays)
    }).catch((error) => {
      commit(RESCHEDULE_SET_LOADING_STATUS_LIST, 'STATUS_END')
      commit(RESCHEDULE_SET_LIST, [])
      if (error.response.status !== 404) {
        commit(RESCHEDULE_SET_LOADING_STATUS_LIST, 'STATUS_FAILED')
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: reload
          }
        })
        submitAnalyticsEvent('Erro ao buscar listagem de recoletas')
      }
    })
  },
  getReschedulesTotalNumber: function ({ commit, state }) {
    commit(RESCHEDULE_SET_LOADING_STATUS_TOTAL, 'STATUS_LOADING')

    rescheduleService.getTotalRescheduledOrders().then(response => {
      commit(RESCHEDULE_SET_LOADING_STATUS_TOTAL, 'STATUS_SUCCESS')
      commit(RESCHEDULE_SET_TOTAL, response.data.rescheduledCount)
      submitAnalyticsEvent('Total de recoletas - sucesso')
    }).catch((error) => {
      commit(RESCHEDULE_SET_LOADING_STATUS_TOTAL, 'STATUS_END')
      commit(RESCHEDULE_SET_TOTAL, 0)
      submitAnalyticsEvent('Falha ao buscar total de Remarcação')
      if (error.response.status !== 404) {
        commit(RESCHEDULE_SET_LOADING_STATUS_TOTAL, 'STATUS_FAILED')
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: reload
          }
        })
      }
    })
  },
  clearAllRescheduleData: function ({ commit }) {
    commit(RESCHEDULE_CLEAR_ALL)
  },
  selectRescheduleParams: function ({ commit }, paramsList) {
    commit(RESCHEDULE_SET_SEARCH_PARAMS, paramsList)
  },
  setWaitingRescheduleLoadingStatus: function ({ commit }) {
    commit(RESCHEDULE_SET_LOADING_STATUS_LIST, 'STATUS_WAITING')
  }
}

let reload = function () {
  window.location.reload()
}

let submitAnalyticsEvent = action => {
  analytics.pushAnalyticsEvent('ga-event', {
    'category': 'Remarcação',
    'action': action
  })
}

export default {
  state,
  mutations,
  actions,
  getters
}
export {
  mutations,
  actions,
  getters
}
